import { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { MessageSquare, X } from "lucide-react";

export default function MessagesBanner() {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState({ total: 0, senders: [] });
  const [dismissed, setDismissed] = useState(false);

  const load = useCallback(() => {
    api.get("/messages/unread").then(({ data }) => setData(data || { total: 0, senders: [] })).catch(() => {});
  }, []);

  useEffect(() => { load(); const t = setInterval(load, 5000); return () => clearInterval(t); }, [load]);

  if (dismissed || !data.total || location.pathname.startsWith("/dashboard/messages")) return null;

  const open = (sender) => navigate("/dashboard/messages", { state: sender ? { openUserId: sender.from_id, openUserName: sender.from_name } : {} });

  return (
    <div className="mx-4 sm:mx-6 lg:mx-8 mt-4" data-testid="messages-banner">
      <div className="rounded-xl border border-[#007AFF]/30 bg-[#007AFF]/10 p-4">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-full bg-[#007AFF]/20 flex items-center justify-center shrink-0">
            <MessageSquare className="w-4 h-4 text-[#4da3ff]" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="text-white text-sm font-medium">
              {data.total} nouveau{data.total > 1 ? "x" : ""} message{data.total > 1 ? "s" : ""} non lu{data.total > 1 ? "s" : ""}
            </p>
            <div className="mt-2 space-y-1.5">
              {data.senders.slice(0, 3).map((s) => (
                <button key={s.from_id} onClick={() => open(s)} data-testid={`banner-sender-${s.from_id}`}
                  className="w-full text-left flex items-center gap-2 text-sm text-zinc-300 hover:text-white transition-colors">
                  <span className="font-medium text-[#4da3ff]">{s.from_name}</span>
                  <span className="text-zinc-500 truncate">— {s.last_body}</span>
                  {s.count > 1 && <span className="ml-auto text-[10px] bg-[#FF3B30] text-white rounded-full px-1.5 py-0.5 shrink-0">{s.count}</span>}
                </button>
              ))}
            </div>
            <button onClick={() => open(null)} data-testid="banner-open-messages" className="mt-2.5 text-xs font-medium text-[#4da3ff] hover:text-white transition-colors">
              Ouvrir la messagerie →
            </button>
          </div>
          <button onClick={() => setDismissed(true)} data-testid="banner-dismiss" className="text-zinc-500 hover:text-white shrink-0"><X className="w-4 h-4" /></button>
        </div>
      </div>
    </div>
  );
}
